// extracted by mini-css-extract-plugin
export default {"container":"Message_container__wPKGD","message":"Message_message__zAJ6w","messageUnread":"Message_messageUnread__CAmv7"};